import type { ReportField } from '../../hooks/useReports';

/**
 * Default resource-report column set + order, ported verbatim from Angular's
 * add_report_modal.js newReport.fields. The user can reorder, rename (outputName),
 * enable/disable, and filter these in the Customize Fields panel.
 */
const NAMES: string[] = [
  'Id', 'ProjectId', 'CollectionId', 'SortKey', 'Custodian',
  // Filename
  'RelativePath', 'BaseName', 'Filename', 'Extension', 'AllPaths',
  // What kind of file
  'Type', 'MimeType', 'Category', 'IsContainer', 'IsRegularFile', 'IsEmail', 'IsSourceData',
  'IsSystemFile', 'IsDuplicateFile', 'HasVirus', 'WasPasswordProtected', 'WasDecrypted', 'Size',
  'SystemTags', 'ProjectTags', 'DomainTags', 'BatchTags',
  // Hash
  'SHA1', 'SHA256', 'SHA512', 'MD5',
  // Ancestry
  'IsTopParentResource', 'TopParentResourceId', 'TopParentCreatedDate', 'ParentResourceId', 'Ancestors',
  'EmbeddedIndex', 'Language',
  'HadProcessingException', 'ProcessingException',
  // PDF Info
  'NumPdfPages', 'HadPdfException', 'PdfException',
  // Core Metadata
  'CreatedDate', 'ModifiedDate', 'PrintDate', 'MetadataDate',
  'Title', 'Creator',
  'EmailFrom', 'EmailTo', 'EmailCc', 'EmailBcc', 'EmailRecipients', 'EmailMessageClass',
  'EmailConversationTopic', 'EmailDomains', 'InternetMessageId',
  'Notes', 'PrivilegedNotes',
  // Bates
  'BegBates', 'EndBates', 'BegAttachBates', 'EndAttachBates',
  'AllBegBates', 'AllEndBates', 'AllBegAttachBates', 'AllEndAttachBates',
  // Entities
  'LocationEntities', 'PersonEntities', 'OrganizationEntities', 'MiscEntities', 'TimeEntities',
  'DateEntities', 'PercentEntities', 'MoneyEntities', 'CommercialItemEntities', 'EventEntities', 'TitleEntities',
];

export function defaultResourceReportFields(): ReportField[] {
  return NAMES.map((name) => ({ type: 'normal', name, outputName: name, isEnabled: true }));
}
